import React, { useState } from "react";
// import rajeev from "../director../images/rajeevahuja.png";
import Ares from "../../images/Ares.jpeg";
import ease from "../../images/easecruit.png";
import Bodyloop from "../../images/BODYLOOP_LABS.jpg";
import chematico from "../../images/chematico.jpeg";
import dakters from "../../images/Dakters.jpg";
import edith from "../../images/edith_health.jpeg";
import epilepto from "../../images/epilepto.png";
import evigway from "../../images/evigway.jpeg";
import fulectronix from "../../images/Fulectronics.webp";
import greeninv from "../../images/GREEN_INNOVOTECH.jpg";
import jyoma from "../../images/JYOMA_SOLUTIONS.jpg";
import logier from "../../images/logier.png";
import nanokriti from "../../images/nanokriti.png";
import neontram from "../../images/Neontram.jpg";
import renao from "../../images/renao.jpg";
import rosch from "../../images/rosch-crete.jpg";
import scratchnest from "../../images/Scratchnest.png";
import wevixit from "../../images/wevixit.jpeg";
import yoboshu from "../../images/yoboshu.png";
import { motion } from "framer-motion";
import vanix from "../../images/vanix.png";
import kalpakaar from "../../images/kalpakaar.png";
import touche from "../../images/touch.png";
import "./portfolio.css";
import { ExternalLink, VenetianMask } from "lucide-react";
import backg from "../../global-images/vector-about.png";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import speedybyte from "../../images/speedbyte1.png";
import citpeels from "../../images/Citpeels.png";
import texoedge from "../../images/Texoedge.jpg";
import yInstrument from "../../images/Y Instrumentation.png";
import Fulectronics from "../../images/Fulectronics.webp";
import Huskage from "../../images/Huskage.png";
import MedXbid from "../../images/MedXbid.png";
import SVIG from "../../images/SVIG.webp";
import dronetech from "../../images/dronetech.png";
import BEF from "../../images/BFP.png";
import agniverse from "../../images/agniverse.png";
import agb from "../../images/agb solution.jpeg";
import ML from "../../images/ML.png";
import DG from "../../images/DG.png";
import zenv from "../../images/zenv.png";
import Samarthya from "../../images/Samarthya.png";
import climmatech from "../../images/climmatech.png";
import zmr from "../../images/zmr.png";
import gudlyf from "../../images/Gudlyf.png";
import Thoughtrons from "../../images/Thoughtrons1.png";
import Evizen from "../../images/Evizen.png";
import BOQO from "../../images/BOQO.png";
import crevings from "../../images/crevings.png";
import Assurity from "../../images/Assurity.png";
import Lino from "../../images/Lino.png";
import Jiyaxo from "../../images/Jiyaxo.png";
import VMS from "../../images/VMS.png";
import Unknown from "../../images/Unknown.png";
import Labrys from "../../images/Labrys.png";
import EVAYU from "../../images/Evayu.png";
import GreedyGame from "../../images/Greedy.png";
import Sookshm from "../../images/Sookshm.png";
import Mtecton from "../../images/M-Tecton.png";
import Smartrashi from "../../images/SmartRashi.png"
import ROBOZENLABS from "../../images/ROBOZENLABS.png"
import dia from "../../images/Diabuddy.png"
import alma from "../../images/Alma.png"
import lit from "../../images/Lit.png"
import GreenFinch from "../../images/Greenfinch.png"
import Farata from "../../images/Farata.png"
import GeoCore from "../../images/GeoCore.png"
import Arrivobus from "../../images/ArrivoBus.png"
import Ocelor from "../../images/Ocelor.png"
import ForteAI from "../../images/Forteai.png"
import Dronosaur from "../../images/Dronosaur.png"
import Nesthome from "../../images/Nesthome.png"
import I from "../../images/I.png"
import V from "../../images/V.png"
import Okdriver from "../../images/Okdriver.png"
import Pragyanikai from "../../images/Pragyanikai.png"
import SourcingXpress from "../../images/SourcingXpress.png"
import Aerial from "../../images/Aerial Borne.png"
import Spatial from "../../images/Spatial Knott.png"
import Flo from "../../images/Flo.png"
import U from "../../images/U.png"
import NextOrbit from "../../images/NextOrbit.png"
import R from "../../images/R.png"
import Chamber from "../../images/Chamber.png"

const marqueeData = [
  {
    img: U,
    name: "",
    description: "",
    link: "",
  },
  {
    img: Spatial,
    name: "Spatialc Knott",
    description: "",
    link: "",
  },
  {
    img: Flo,
    name: "",
    description: "",
    link: "",
  },
  {
    img: NextOrbit,
    name: "NextOrbit",
    description: "",
    link: "",
  },
  {
    img: R,
    name: "",
    description: "",
    link: "",
  },
  {
    img: Chamber,
    name: "Chamber 5",
    description: "",
    link: "",
  },
  {
    img: Okdriver,
    name: "OkDriver",
    description: "",
    link: "",
  },
  {
    img: Pragyanikai,
    name: "Pragyanik AI Pvt. Ltd.",
    description: "",
    link: "",
  },
  {
    img: SourcingXpress,
    name: "",
    description: "",
    link: "",
  },
  {
    img: Aerial,
    name: "Aerial Borne",
    description: "",
    link: "",
  },
  {
    img: V,
    name: "",
    description: "",
    link: "",
  },
  {
    img: I,
    name: "",
    description: "",
    link: "",
  },
  {
    img: Ocelor,
    name: "Ocelor Technologies private limited",
    description: "",
    link: "",
  },
  {
    img: ForteAI,
    name: "FORTEAI",
    description: "",
    link: "",
  },
  {
    img: Dronosaur,
    name: "Dronosaur",
    description: "",
    link: "",
  },
  {
    img: Nesthome,
    name: "Nesthome",
    description: "",
    link: "",
  },
  {
    img: Arrivobus,
    name: "ARRIVOBus Tech. PVT. LTD.",
    description: "",
    link: "",
  },
  {
    img: GeoCore,
    name: "GEOCORE Tech.",
    description: "",
    link: "",
  },
  {
    img: Farata,
    name: "Farata Tech.",
    description: "",
    link: "",
  },
  {
    img: GreenFinch,
    name: "GreenFinch",
    description: "",
    link: "",
  },
  {
    img: lit,
    name: "L.I.T Labs",
    description: "",
    link: "",
  },
  {
    img: alma,
    name: "Alma Threads",
    description: "",
    link: "",
  },
  {
    img: dia,
    name: "Diabuddy",
    description: "",
    link: "",
  },
  {
    img: ROBOZENLABS,
    name: "ROBOZENLABS",
    description: "",
    link: "",
  },
  {
    img: Smartrashi,
    name: "SmartRashi",
    description: "",
    link: "",
  },
  {
    img: Mtecton,
    name: "M-Tecton",
    description: "",
    link: "",
  },
  {
    img: Sookshm,
    name: "SOOKSHM Instruments PVT. LTD.",
    description: "",
    link: "",
  },
  {
    img: GreedyGame,
    name: "GREEDY GAME",
    description: "",
    link: "",
  },
  {
    img: EVAYU,
    name: "EVAYU",
    description: "",
    link: "",
  },
  {
    img: Labrys,
    name: "LABRYS",
    description: "",
    link: "",
  },
  {
    img: Unknown,
    name: "",
    description: "",
    link: "",
  },
  {
    img: Jiyaxo,
    name: "JIYAXO TECHNO",
    description: "",
    link: "",
  },
  {
    img: Lino,
    name: "Lino",
    description: "",
    link: "",
  },
  {
    img: Assurity,
    name: "ASSURITY",
    description: "",
    link: "",
  },
  {
    img: crevings,
    name: "CREVINGS",
    description: "",
    link: "",
  },
  {
    img: BOQO,
    name: "BOQO",
    description: "",
    link: "",
  },
  {
    img: Evizen,
    name: "Evizen AI",
    description: "",
    link: "",
  },
  {
    img: Thoughtrons,
    name: "Thoughtrons",
    description: "",
    link: "",
  },
  {
    img: gudlyf,
    name: "Gudlyf",
    description: "",
    link: "",
  },
  {
    img: zmr,
    name: "ZMR Mobility Pvt. Ltd.",
    description: "",
    link: "",
  },
  {
    img: climmatech,
    name: "ClimaTech",
    description: "",
    link: "",
  },
  {
    img: Samarthya,
    name: "Samarthya Defence",
    description: "",
    link: "",
  },
  {
    img: zenv,
    name: "Zenv Academy",
    description: "",
    link: "",
  },
  {
    img: ease,
    name: "Easecruit",
    description: "Easecruit is a company that provides ",
    link: "http://www.easecruit.com",
  },
  {
    img: Ares,
    name: "Ares Systems",
    description: "Ares Systems is a company that provides ",
    link: "http://www.aressystems.io/",
  },
  {
    img: speedybyte,
    name: "Speedybyte",
    description:
      "Speedybyte is a company that provides fast delivery services.",
    link: "http://speedybyte.co.in/",
  },
  {
    img: Bodyloop,
    name: "Bodyloop labs",
    link: "/",
    description: "Bodyloop labs is a company that provides ",
  },
  {
    img: edith,
    name: "Edith Healthcare",
    link: "https://www.nanokriti.com/",
    description: "Edith Robotics Solutions is a company that provides ",
  },
  {
    img: scratchnest,
    name: "ScratchNest",
    link: "https://scratchnest.com/",
    description: "ScratchNest is a company that provides ",
  },
  {
    img: vanix,
    name: "Vanix Technologies",
    link: "https://vanixtechnologies.com/",
    description: "Vanix Technologies is a company that provides ",
  },
  {
    img: yoboshu,
    name: "Yoboshu",
    link: "https://www.nanokriti.com/",
    description: "Yoboshu is a company that provides ",
  },
  {
    img: logier,
    name: "Logier Technologies",
    link: "https://www.nanokriti.com/",
    description: "Logier Technologies is a company that provides ",
  },
  {
    img: jyoma,
    name: "Jyoma Solutions",
    link: "https://jyomasolutions.com/",
    description: "Jyoma Solutions is a company that provides ",
  },
  {
    img: greeninv,
    name: "Green Innovotech",
    link: "http://www.greeninnovotech.com/",
    description: "Green Innovotech is a company that provides ",
  },
  {
    img: neontram,
    name: "Neontram Pvt ltd",
    link: "http://www.neontram.com/",
    description: "Neontram Pvt ltd is a company that provides ",
  },
  {
    img: nanokriti,
    name: "Nanokriti Pvt ltd",
    link: "https://www.nanokriti.com/",
    description:
      "Roschchcrete Technologies Pvt ltd is a company that provides ",
  },
  {
    img: rosch,
    name: "Roschchcrete Technologies Pvt ltd",
    link: "http://roschcrete.com/",
    description:
      "Roschchcrete Technologies Pvt ltd is a company that provides ",
  },
  {
    img: renao,
    name: "Renao Robotics",
    link: "https://www.nanokriti.com/",
    description:
      "Roschchcrete Technologies Pvt ltd is a company that provides ",
  },
  {
    img: fulectronix,
    name: "Fulectronix Technologies ",
    link: "http://www.fulectronix.in/",
    description:
      "Roschchcrete Technologies Pvt ltd is a company that provides ",
  },
  {
    img: evigway,
    name: "Evigway Technologies",
    link: "http://www.evigway.com/",
    description:
      "Roschchcrete Technologies Pvt ltd is a company that provides ",
  },
  {
    img: epilepto,
    name: "Epilepto Systems",
    link: "www.Epilepto.com",
    description:
      "Roschchcrete Technologies Pvt ltd is a company that provides ",
  },
  {
    img: chematico,
    name: "Chematico Technologies",
    link: "http://www.chematico.com/",
    description:
      "Roschchcrete Technologies Pvt ltd is a company that provides ",
  },
  {
    img: dakters,
    name: "Dakters",
    link: "https://www.nanokriti.com/",
    description:
      "Roschchcrete Technologies Pvt ltd is a company that provides ",
  },
  {
    img:VMS,
    name: "VMS healthcare solution Pvt Ltd (Medvolent)",
    description:
      "Revolutionizing healthcare in India by developing a one-stop solution for hospitals and clinics i.e. developing a health kiosk for Rural areas Primary healthcare centers in India. Other Solutions include drone deliveries, AI enabled WhatsApp tools, data-driven procurement services. Promoting quality healthcare services accessible to all.",
    link: "https://medvolant.in/myorders",
  },

  {
    img: kalpakaar,
    name: "Kalpkaar Aesthetics Pvt. Ltd",
    description:
      "The startup deals in the manufacturing of bamboo furniture, miniatures, lamps, bamboo bottles, packaging, and bio-curtains. Their target audience in B2B is Government department (Tourism, Horticulture, Handicrafts & Handloom), Hotels, restaurants etc. and in B2C is HIG's (High Income Groups) and upper middle-class segments. They are now developing Bamboo Curtain/Bio Curtain and Bamboo Packing Boxes using Bamboo and plants together for the Bio Curtains which will replace the conventional polyester-based curtains.",
    link: "",
  },
  {
    img: touche,
    name: "Touch Computing Technologies Pvt Ltd",
    description:
      "Develop next generation computing and communicating devices powered by browser based operating system.",
    link: "http://touchtechnologies.in/",
  },
  {
    img:citpeels,
    name:"CitPeels"
  },
  {
    img: texoedge,
    name: "Texoedge",
    link: "https://texoedge.in/"
  },
  {
    img: yInstrument,
    name: "Y Instrumentation"
  },
  // {
  //   img: Fulectronics,
  //   name: "Fulectronix"
  // },
  {
    img: Huskage,
    name: "Huskage"
  },
  {
    img: MedXbid,
    name: "MedXbid"
  },
  {
    img: SVIG,
    name: "SVIG"
  },
  {
    img: dronetech,
    name: "DroneTech"
  },
  {
    img: BEF,
    name: "BEF"
  },
  {
    img: agniverse,
    name: "Agniverse"
  },
  {
    img: agb,
    name: "AGB"
  },
  {
    img: ML,
    name: "ML workX"
  },
  {
    img: DG,
    name: "Dg"
  },



];
const itemsPerPage = 12;
function Portfolio() {
  const [currentPage, setCurrentPage] = useState(1);
  const element = document.getElementById("portfolio-box");
  // const totalPages = Math.ceil(marqueeData.length / itemsPerPage);

  // const handleClickNext = () => {
  //   if (currentPage < totalPages) {
  //     setCurrentPage(currentPage + 1);
  //   }
  //   if (element) {
  //     window.scrollTo({
  //       top: element.offsetTop,
  //       behavior: 'smooth'
  //     });
  //   }
  // };
  const sortedMarqueeData = marqueeData.sort((a, b) => {
    const nameA = a.name.toUpperCase(); // Ignore case
    const nameB = b.name.toUpperCase(); // Ignore case

    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }

    // Names must be equal
    return 0;
  });

  // console.log(sortedMarqueeData);

  // const handleClickPrev = () => {
  //   if (currentPage > 1) {
  //     setCurrentPage(currentPage - 1);
  //   }
  //   if (element) {
  //     window.scrollTo({
  //       top: element.offsetTop,
  //       behavior: 'smooth'
  //     });
  //   }
  // };
  // const currentItems = marqueeData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    // <div className='w-screen'>
    <div
      className="bg-white flex items-center justify-center  lg:py-20  md:py-15 sm:py-20 xs:py-20 "
      id="portfolio"
    >
      <div>
        <div>
          <h1 className="text-4xl pt-4 font-montserrat text-black text-center ">
            <span className="text-blue-600 font-bold  text-6xl">O</span>ur{" "}
            <span className="font-bold font-mono  text-4xl">I</span>ncubatees{" "}
          </h1>
        </div>
        <div className="rounded-3xl">
          <div className=" flex justify-center  items-center font-montserrat relative">
            {/* <div id='circle-1' className='absolute w-72 h-72 lg:top-0 lg:left-0 sm:top-50 sm:left-0 bg-purple-400 rounded-full mix-blend-multiply filter blur-lg opacity-80'></div> */}

            <div className=" flex grid grid-cols-1  justify-center items-center relative p-6 ">
              {/* <div id='circle-3' className='absolute w-72 h-72 lg:top-0 lg:left-0 sm:top-0 sm:left-0 bg-red-400 animate-pulse  rounded-full mix-blend-multiply filter blur-lg opacity-80'></div> */}
              {/* <div id='circle-2' className='absolute w-72 h-72 lg:top-40 lg:left-0 sm:top-0 sm:left-10 bg-indigo-400 rounded-full mix-blend-multiply filter blur-lg opacity-80'></div> */}

              <div
                className="bg-white flex items-center justify-center"
                id="portfolio"
              >
                <div className=" rounded-3xl">
                  <div className=" flex justify-center items-center font-montserrat relative">
                    {/* <div id='circle-1' className='absolute w-72 h-72 lg:top-0 lg:left-0 sm:top-50 sm:left-0 bg-purple-400 rounded-full mix-blend-multiply filter blur-lg opacity-80'></div> */}

                    {/* <div className=' flex grid grid-cols-1 flex justify-center items-center relative '> */}
                    {/* <div id='circle-3' className='absolute w-72 h-72 lg:top-0 lg:left-0 sm:top-0 sm:left-0 bg-red-400 animate-pulse  rounded-full mix-blend-multiply filter blur-lg opacity-80'></div> */}
                    {/* <div id='circle-2' className='absolute w-72 h-72 lg:top-40 lg:left-0 sm:top-0 sm:left-10 bg-indigo-400 rounded-full mix-blend-multiply filter blur-lg opacity-80'></div> */}

                    <div
                      className=" flex"
                      id="portfolio-box"
                    >
                      <div
                        className="grid lg:grid-cols-4 md:grid-cols-2 gap-x-6 h-full w-full flex-wrap"
                      >
                        {marqueeData.map((portfolio, index) => (
                          <div className="flex justify-center items-center  mx-4 my-10">
                            <div
                              className="border  border-5 transition-all hover:scale-105 duration-100 rounded-xl hover:transition hover:ease-in-out   hover:text-white hover:duration-500  border-blue-500 flex flex-col grid-cols-1 card img-card justify-center items-center hover:shadow-2xl gap-6 bg-zinc-900 hover:border-2"
                              id="startup box"
                            >
                              <div className="flex bg-white rounded-3xl w-52 h-48 overflow-hidden border p-3 border-white justify-center items-center ">
                                <img
                                  className=""
                                  src={portfolio.img}
                                ></img>
                              </div>
                              <div className="bg-opacity-30">
                                <div
                                  className=" text-center text-xl font-montserrat text-white hover:underline hover:underline-offset-4"
                                  id="title"
                                >
                                  {portfolio.name}
                                </div>
                              </div>
                              <a
                                className="flex justify-around items-center "
                                href={portfolio.link}
                                target="_blank"
                              >
                                <button className="p-3 rounded-2xl ">
                                  <h2 className="text-md font-sans flex-row text-sky-400 hover:text-blue-500 hover-underline-animation">
                                    <span className="flex items-center">
                                      Visit Website
                                      <ExternalLink className="mb-1"></ExternalLink>
                                    </span>
                                  </h2>
                                </button>
                              </a>
                            </div>
                            {/* </div> */}
                            {/* </div> */}
                          </div>
                          // </div>
                        ))}
                      </div>
                      {/* <div></div> */}
                      {/* <div className=''><div className='text-white underline-offset-4 underline  font-bold text-xl text-center m-4 p-4'>Page {currentPage}</div></div> */}
                      {/* <div className='flex justify-end grid grid-cols-2 '>
                          <button className='text-white bg-red-800 hover:bg-pink-600  p-4 m-4 rounded-lg transition ease-in-out hover:scale-105 transform-400 hover:shadow-[0_0_10px_white]' onClick={handleClickPrev}>Previous</button>
                          <button className='text-white bg-green-900 hover:bg-emerald-400 m-4 rounded-lg transition ease-in-out hover:scale-105 transform-400 hover:shadow-[0_0_10px_white]' onClick={handleClickNext}>Next</button>
                        </div> */}
                      {/* </div > */}
                    </div>
                  </div>
                  {/* </div> */}
                </div>
              </div>
              <div className="bg-black mt-10 rounded-3xl py-12 sm:py-16 px-4 sm:px-6 lg:px-8 ">
                <div className="max-w-7xl mx-auto text-center flex grid justify-center items-center">
                  <div>
                    <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-white">
                      Interested in joining our portfolio?
                    </h2>
                    <p className="mt-3 sm:mt-4 text-lg sm:text-xl text-gray-300">
                      We're always looking for innovative startups to support
                      and grow.
                    </p>
                  </div>
                  <div className="mt-10">
                    <Link
                      to="/contact-us"
                      className="inline-flex items-center p-4 font-bold border border-transparent text-base hover:bg-blue-600 hover:shadow-2xl font-medium rounded-md text-white bg-blue-500  duration-450 ease-in-out"
                      onClick={() =>
                        window.scrollTo({ top: 0, behavior: "smooth" })
                      }
                    >
                      Get in Touch
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* </div> */}
        </div>
      </div>
    </div>
  );
}

export default Portfolio;
